// 导入封装好的网络请求类工具
import Network from './network';

// 封装各种接口请求
// export const 接口名 = () => Network.get('/路由',参数对象);
export const gethotShops = () => Network.get('/api/hotShops', {});//获取热门商品
export const getCats = () => Network.get('/api/cats', {});//获取分类列表
// export const getCatshops = () => Network.get('/api/catShop', {});//获取带产品列表的分类列表
export const getShopsDet = (gid) => Network.get('/api/shopDetail', {id:gid});//获取商品详情
export const getShops = (cid,pageIndex,pageSize) => Network.get('/api/shops', {catid:cid,pageIndex:pageIndex,pageSize:pageSize});//获取商品详情
export const getnews = (pageIndex,pageSize) => Network.get('/api/news', {pageIndex:pageIndex,pageSize:pageSize});//获取文章列表
export const getsomeShops = (gid) => Network.get('/api/someShops', {id:gid});//获取文章列表
export const getnewsDet = (nid) => Network.get('/api/newsDetail', {id:nid});//获取文章详情
export const getEnquiryCode = () => Network.get('/api/getEnquiryCode', {});//获取询单验证码

//备份
// export const postForm = (form) =>
//     Network.post('/api/pushContact',
//         {name:form.name,jobTitle:form.jobTitle,companyName:form.companyName,email:form.email,phoneNumber:form.phoneNumber,message:form.message,});//发布询单（联系页）
export const postForm = (form) => Network.post('/api/pushContact',{
    name:form.name,
    jobTitle:'',
    companyName:'',
    email:form.email,
    phoneNumber:'',
    message:form.message,
});//发布询单（联系页）
export const postForm2 = (form,session) =>Network.post('/api/pushEnquiry',{//后台未完善 发布询单（产品页）
    shopId:0,
    shopSku:form.CnR,
    quantity: 0,
    contactName:form.name,
    contactCompany:form.CnN,
    contactEMail:form.email,
    contactTel:form.tel,
    message:form.message,
    codeSession:session,
    sourceUrl:'',
    enquirySource:'',
    verifyCode:form.VerifyCode,
    enquiryType: 0,
});
